// extracted by mini-css-extract-plugin
module.exports = {"container":"loginForm-modules--container--gYPA0","input":"loginForm-modules--input--1ZQ5K","button":"loginForm-modules--button--2vLNK","logo":"loginForm-modules--logo--3CQB8"};